/* Dirty Dogs (dirtydogs.com Shopify theme): carry a Google ad click into the MoeGo booking frame.
 *
 * Ads land on dirtydogs.com with ?gclid=… (or gbraid/wbraid); the store booking pages embed MoeGo in an iframe
 * whose src is fixed, so the click id never reached MoeGo. MoeGo's booking app reads gclid, gbraid, _gl, gad_*
 * and utm_* from its own URL and saves them with the new client, which is what its Google Ads integration
 * attributes. This script keeps the click for 90 days (Google's click window) in first-party storage and adds
 * it to every booking.moego.pet/ol/ frame on the page. It respects Shopify's customer privacy opt-out, makes
 * no fetch requests itself (rewriting src loads MoeGo), and leaves the page untouched when there is no stored click.
 */
(function (root) {
  'use strict';
  var KEY = 'dd_ads_click_v1';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var LOADER_AFTER = 8; // polls (500 ms each) before the fallback loader runs
  var LOADER_VERSION = '0.1'; // the version the Dirty Dogs theme's cookie banner requests
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];
  var CARRIED = CLICK_IDS.concat(['_gl', 'gad_source', 'gad_campaignid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']);
  var MOEGO = /^https:\/\/booking\.moego\.pet\/ol\//;

  function allowed(win) {
    var privacy = win.Shopify && win.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return null;
    try { return privacy.marketingAllowed() === true; } catch (e) { return false; }
  }

  function storage(win) {
    try { return win.localStorage; } catch (e) { return null; }
  }

  function clean(params) {
    var result = {};
    if (!params || typeof params !== 'object' || Array.isArray(params)) return null;
    CARRIED.forEach(function (key) {
      var value = Object.prototype.hasOwnProperty.call(params, key) && params[key];
      if (typeof value === 'string' && value.length > 0 && value.length <= 512) result[key] = value;
    });
    return CLICK_IDS.some(function (key) { return result[key]; }) ? result : null;
  }

  // A landing URL with a valid click id becomes the stored click.
  function capture(search, now) {
    var query = new URLSearchParams(search || '');
    var params = {};
    CARRIED.forEach(function (key) { params[key] = query.get(key); });
    params = clean(params);
    return params ? { at: now, params: params } : null;
  }

  function read(store, now) {
    if (!store) return null;
    try {
      var click = JSON.parse(store.getItem(KEY) || 'null');
      if (!click || typeof click.at !== 'number' || !isFinite(click.at) || !clean(click.params) || now - click.at > MAX_AGE_MS || click.at > now) {
        store.removeItem(KEY);
        return null;
      }
      var kept = { at: click.at, params: clean(click.params) };
      // A record carrying anything outside the allowlist is rewritten to what may travel; its age is unchanged.
      if (JSON.stringify(kept.params) !== JSON.stringify(click.params)) store.setItem(KEY, JSON.stringify(kept));
      return kept;
    } catch (e) {
      return null;
    }
  }

  // The click's own utm values replace the embed's utm_medium=embed so MoeGo sees the ad source.
  function decorate(src, params) {
    var url = new URL(src);
    params = clean(params);
    if (!params) return src;
    var hasUtm = Object.keys(params).some(function (key) { return key.indexOf('utm_') === 0; });
    var remove = [];
    if (hasUtm) {
      url.searchParams.forEach(function (value, key) { if (key.indexOf('utm_') === 0) remove.push(key); });
      remove.forEach(function (key) { url.searchParams.delete(key); });
    }
    CARRIED.forEach(function (key) { if (key.indexOf('utm_') !== 0) url.searchParams.delete(key); });
    Object.keys(params).forEach(function (key) { url.searchParams.set(key, params[key]); });
    return url.toString();
  }

  function run(win, doc, now) {
    if (typeof URL !== 'function' || typeof URLSearchParams !== 'function') return 0;
    var consent = allowed(win);
    if (consent === null) return 0;
    if (!consent) {
      var blocked = storage(win);
      if (blocked) try { blocked.removeItem(KEY); } catch (e) { /* storage refused */ }
      Array.prototype.forEach.call(doc.querySelectorAll('iframe[src]'), function (frame) {
        var previous = frame.ddAdsClickSource;
        if (previous && frame.getAttribute('src') === previous.next) frame.setAttribute('src', previous.original);
        frame.ddAdsClickSource = null;
      });
      return 0;
    }
    var store = storage(win);
    var captured = capture(win.location.search, now);
    var saved = read(store, now);
    var click = captured || saved;
    if (captured && saved && JSON.stringify(captured.params) === JSON.stringify(saved.params)) click = saved;
    if (!click) return 0;
    if (store && click !== saved) try { store.setItem(KEY, JSON.stringify(click)); } catch (e) { /* storage refused: this page still carries it */ }
    var changed = 0;
    Array.prototype.forEach.call(doc.querySelectorAll('iframe[src]'), function (frame) {
      var src = frame.getAttribute('src');
      if (!MOEGO.test(src)) return;
      var next;
      try { next = decorate(src, click.params); } catch (e) { return; }
      if (next !== src) {
        var previous = frame.ddAdsClickSource;
        frame.ddAdsClickSource = { original: previous && previous.next === src ? previous.original : src, next: next, params: clean(click.params) };
        frame.setAttribute('src', next);
        changed += 1;
      }
    });
    return changed;
  }

  // MoeGo's booking app posts {type: 'moego_storefront_event', payload: {type, customProps}} to the page that embeds
  // it. A booking made in a frame this script carried a click into is reported, with that frame's click, so the
  // Doghouse can tie the ad click to the MoeGo appointment. Nothing is sent without an endpoint (set at release),
  // marketing consent at the moment of sending, or a frame we decorated; only allow-listed ids travel.
  var EVENT_ORIGIN = 'https://booking.moego.pet';
  var ENDPOINT = 'https://dirtydogs.wellbuilt.systems/t/booking';
  var REPORTED = ['booking_iframe_open', 'appointment_succeeded'];
  var MOEGO_PROPS = ['appointmentId', 'customerId', 'locationId', 'serviceCategory'];
  // 128 characters covers Google click ids and MoeGo ids and keeps a full body under the intake's 2 KB limit.
  var ID = /^[A-Za-z0-9._-]{1,128}$/;
  // Only the store booking pages; the intake checks the exact store against its allow-list. Six stores use
  // /pages/book-appointments-at-<store>; Leucadia's page is /pages/appointments-at-leucadia (storefront, 2026-10-28).
  var PAGE = /^\/pages\/(?:book-)?appointments-at-[a-z0-9-]{1,60}$/;
  var RETRY_MS = [1000, 4000];

  function boundFrame(doc, source) {
    var frames = doc.querySelectorAll('iframe[src]');
    for (var i = 0; i < frames.length; i += 1) {
      var frame = frames[i];
      if (frame.contentWindow === source && frame.ddAdsClickSource && frame.ddAdsClickSource.params && MOEGO.test(frame.getAttribute('src'))) return frame;
    }
    return null;
  }

  function nonce(win) {
    var bytes = [];
    try {
      var buffer = new Uint8Array(18);
      win.crypto.getRandomValues(buffer);
      bytes = Array.prototype.slice.call(buffer);
    } catch (e) {
      for (var i = 0; i < 18; i += 1) bytes.push(Math.floor(Math.random() * 256));
    }
    var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    return bytes.map(function (b) { return alphabet[b & 63]; }).join('');
  }

  function body(win, frame, payload, now) {
    var path = win.location.pathname;
    if (!PAGE.test(path || '')) return null;
    var click = {};
    CLICK_IDS.forEach(function (key) {
      var value = frame.ddAdsClickSource.params[key];
      if (typeof value === 'string' && ID.test(value)) click[key] = value;
    });
    if (!Object.keys(click).length) return null;
    var moego = {};
    var props = payload.customProps && typeof payload.customProps === 'object' ? payload.customProps : {};
    MOEGO_PROPS.forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(props, key) || props[key] === null || props[key] === undefined) return;
      var value = String(props[key]);
      if (ID.test(value)) moego[key] = value;
    });
    return { v: 1, event: payload.type, click: click, moego: moego, store_slug: path.slice(7), page_path: path,
      client_ts: new Date(now).toISOString(), nonce: nonce(win) };
  }

  // Bounded retries for network errors and server errors only; consent is checked again before every attempt.
  function deliver(win, endpoint, payload, attempt) {
    if (allowed(win) !== true || typeof win.fetch !== 'function') return;
    var retry = function () {
      if (attempt < RETRY_MS.length) win.setTimeout(function () { deliver(win, endpoint, payload, attempt + 1); }, RETRY_MS[attempt]);
    };
    try {
      win.fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (response) { if (response.status >= 500) retry(); }, retry);
    } catch (e) { retry(); }
  }

  function listen(win, doc, endpoint) {
    if (!endpoint || typeof win.addEventListener !== 'function') return false;
    win.addEventListener('message', function (event) {
      try {
        if (event.origin !== EVENT_ORIGIN) return;
        var data = event.data;
        if (!data || data.type !== 'moego_storefront_event' || !data.payload || REPORTED.indexOf(data.payload.type) < 0) return;
        var frame = boundFrame(doc, event.source);
        if (!frame || allowed(win) !== true) return;
        var payload = body(win, frame, data.payload, Date.now());
        if (!payload) return;
        // One report per frame, event and appointment: MoeGo re-renders the success screen.
        var key = payload.event + '|' + (payload.moego.appointmentId || '');
        frame.ddAdsReported = frame.ddAdsReported || {};
        if (frame.ddAdsReported[key]) return;
        frame.ddAdsReported[key] = true;
        deliver(win, endpoint, payload, 0);
      } catch (e) { /* never break the page */ }
    });
    return true;
  }

  // One lifecycle per page, including duplicate script tags. No attribution before privacy is ready: Shopify's
  // customer privacy API is requested through Shopify's own loader when the theme has not loaded it, polled briefly
  // until it answers, and a booking frame added or re-pointed later re-runs the carry.
  function boot(win, doc) {
    if (win.ddAdsClickStarted) return null;
    win.ddAdsClickStarted = true;
    listen(win, doc, ENDPOINT);
    var start = function () { return run(win, doc, Date.now()); };
    // The theme's own cookie banner loads the privacy API and throws if another script already loaded a different
    // version first (live 2026-10-22: its banner then never showed). So the theme goes first; only a page that still
    // lacks the API after LOADER_AFTER polls gets Shopify's loader, at the version this theme requests.
    var loaderTried = false;
    var fallbackLoader = function () {
      var shopify = win.Shopify;
      if (loaderTried || !shopify || shopify.customerPrivacy || typeof shopify.loadFeatures !== 'function') return;
      loaderTried = true;
      try { shopify.loadFeatures([{ name: 'consent-tracking-api', version: LOADER_VERSION }], function () { start(); }); } catch (e) { /* loader refused */ }
    };
    doc.addEventListener('visitorConsentCollected', start);
    var tries = 0;
    var timer = win.setInterval(function () {
      tries += 1;
      if (tries === LOADER_AFTER) fallbackLoader();
      start();
      if ((allowed(win) !== null || tries >= 30) && typeof win.clearInterval === 'function') win.clearInterval(timer);
    }, 500);
    if (win.MutationObserver) {
      new win.MutationObserver(function (records) {
        for (var i = 0; i < records.length; i += 1) {
          var record = records[i];
          if (record.type === 'attributes' ? record.target.tagName === 'IFRAME' : Array.prototype.some.call(record.addedNodes, function (node) {
            return node.nodeType === 1 && (node.tagName === 'IFRAME' || (node.querySelector && node.querySelector('iframe')));
          })) { start(); return; }
        }
      }).observe(doc.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
    else start();
    return timer;
  }

  root.ddAdsClick = { capture: capture, read: read, decorate: decorate, run: run, boot: boot, listen: listen, KEY: KEY, MAX_AGE_MS: MAX_AGE_MS };
  if (typeof document !== 'undefined' && typeof window !== 'undefined') boot(window, document);
})(typeof window !== 'undefined' ? window : globalThis);
